import { atom, selectorFamily } from "recoil";
import { ServiceWaitList } from "src/services/agenda/waitlist";

export const errorsWaitListState = atom({
  key: "errorsWaitList",
  default: {
    speciality: [],
    professional: [],
    fechaIni: [],
    fechaFin: [],
  },
});

export const professionalsWaitListState = atom({
  key: "professionalsWaitList",
  default: [],
});

export const professionalsFetchState = selectorFamily({
  key: "professionalsFetch",
  get: (specialityCode, dayDefaultAvailable) => async () => {
    const date = dayDefaultAvailable?.toISOString().split("T")[0];
    const { data } = await ServiceWaitList.getProfessionals(
      specialityCode,
      date
    );
    return data;
  },
});

export const specialitiesWaitListState = atom({
  key: "specialitiesWaitList",
  default: [],
});

export const specialitiesFetchState = selectorFamily({
  key: "specialitiesFetch",
  get: (dayDefaultAvailable) => async () => {
    const date = dayDefaultAvailable?.toISOString().split("T")[0];
    const { data } = await ServiceWaitList.getSpecialities(date);
    return data;
  },
});

export const specialitiesByProfessionalFetchState = selectorFamily({
  key: "specialitiesByProfessionalFetch",
  get: (professionalCode) => async () => {
    const { data } = await ServiceWaitList.getSpecialitiesByProfessional(
      professionalCode
    );
    return data;
  },
});

export const professionalWaitListState = atom({
  key: "professionalWaitList",
  default: {
    code: null,
    value: "",
    agp_correl: null,
  },
});

export const specialityWaitListState = atom({
  key: "specialityWaitList",
  default: {
    code: null,
    value: "",
  },
});

export const fechaIniWaitListState = atom({
  key: "fechaIniWaitList",
  default: "",
});

export const fechaFinWaitListState = atom({
  key: "fechaFinWaitList",
  default: "",
});

export const disabledSelectState = atom({
  key: "disabledSelect",
  default: false,
});

export const showWaitListState = atom({
  key: "showWaitList",
  default: false,
});

export const resumeWaitListState = atom({
  key: "resumeWaitList",
  default: null,
});
